
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/[city]/product/[product]",
      function () {
        return require("private-next-pages/[city]/product/[product].tsx");
      }
    ]);
  